export const SUPPORTED_COUNTRIES = [
  {
    title: 'algeria',
    ID: 'ALGERIA',
    countryCode: 'DZ'
  },
  {
    title: 'argentina',
    ID: 'ARGENTINA',
    countryCode: 'AR'
  },
  {
    title: 'australia',
    ID: 'AUSTRALIA',
    countryCode: 'AU'
  },
  {
    title: 'austria',
    ID: 'AUSTRIA',
    countryCode: 'AT'
  },
  {
    title: 'bangladesh',
    ID: 'BANGLADESH',
    countryCode: 'BD'
  },
  {
    title: 'belgium',
    ID: 'BELGIUM',
    countryCode: 'BE'
  },
  {
    title: 'brazil',
    ID: 'BRAZIL',
    countryCode: 'BR'
  },
  {
    title: 'canada',
    ID: 'CANADA',
    countryCode: 'CA'
  },
  {
    title: 'chile',
    ID: 'CHILE',
    countryCode: 'CL'
  },
  {
    title: 'china',
    ID: 'CHINA',
    countryCode: 'CN'
  },
  {
    title: 'colombia',
    ID: 'COLOMBIA',
    countryCode: 'CO'
  },
  {
    title: 'cyprus',
    ID: 'CYPRUS',
    countryCode: 'CY'
  },
  {
    title: 'czech-republic',
    ID: 'CZECH_REPUBLIC',
    countryCode: 'CZ'
  },
  {
    title: 'denmark',
    ID: 'DENMARK',
    countryCode: 'DK'
  },
  {
    title: 'dominican-republic',
    ID: 'DOMINICAN_REPUBLIC',
    countryCode: 'DO'
  },
  {
    title: 'ecuador',
    ID: 'ECUADOR',
    countryCode: 'EC'
  },
  {
    title: 'egypt',
    ID: 'EGYPT',
    countryCode: 'EG'
  },
  {
    title: 'england',
    ID: 'ENGLAND',
    countryCode: 'GB',
    regionName: 'England'
  },
  {
    title: 'ethiopia',
    ID: 'ETHIOPIA',
    countryCode: 'ET'
  },
  {
    title: 'finland',
    ID: 'FINLAND',
    countryCode: 'FI'
  },
  {
    title: 'france',
    ID: 'FRANCE',
    countryCode: 'FR'
  },
  {
    title: 'germany',
    ID: 'GERMANY',
    countryCode: 'DE'
  },
  {
    title: 'greece',
    ID: 'GREECE',
    countryCode: 'GR'
  },
  {
    title: 'hong-kong',
    ID: 'HONG_KONG',
    countryCode: 'HK'
  },
  {
    title: 'hungary',
    ID: 'HUNGARY',
    countryCode: 'HU'
  },
  {
    title: 'india',
    ID: 'INDIA',
    countryCode: 'IN'
  },
  {
    title: 'indonesia',
    ID: 'INDONESIA',
    countryCode: 'ID'
  },
  {
    title: 'iran',
    ID: 'IRAN',
    countryCode: 'IR'
  },
  {
    title: 'iraq',
    ID: 'IRAQ',
    countryCode: 'IQ'
  },
  {
    title: 'ireland',
    ID: 'IRELAND',
    countryCode: 'IE'
  },
  {
    title: 'israel',
    ID: 'ISRAEL',
    countryCode: 'IL'
  },
  {
    title: 'italy',
    ID: 'ITALY',
    countryCode: 'IT'
  },
  {
    title: 'japan',
    ID: 'JAPAN',
    countryCode: 'JP'
  },
  {
    title: 'kazakhstan',
    ID: 'KAZAKHSTAN',
    countryCode: 'KZ'
  },
  {
    title: 'korea-republic-of',
    ID: 'KOREA_REPUBLIC_OF',
    countryCode: 'KR'
  },
  {
    title: 'latvia',
    ID: 'LATVIA',
    countryCode: 'LV'
  },
  {
    title: 'lithuania',
    ID: 'LITHUANIA',
    countryCode: 'LT'
  },
  {
    title: 'malaysia',
    ID: 'MALAYSIA',
    countryCode: 'MY'
  },
  {
    title: 'mexico',
    ID: 'MEXICO',
    countryCode: 'MX'
  },
  {
    title: 'morocco',
    ID: 'MOROCCO',
    countryCode: 'MA'
  },
  {
    title: 'myanmar',
    ID: 'MYANMAR',
    countryCode: 'MM'
  },
  {
    title: 'netherlands',
    ID: 'NETHERLANDS',
    countryCode: 'NL'
  },
  {
    title: 'nigeria',
    ID: 'NIGERIA',
    countryCode: 'NG'
  },
  {
    title: 'northern-ireland',
    ID: 'NORTHERN_IRELAND',
    countryCode: 'GB',
    regionName: 'Northern Ireland'
  },
  {
    title: 'norway',
    ID: 'NORWAY',
    countryCode: 'NO'
  },
  {
    title: 'pakistan',
    ID: 'PAKISTAN',
    countryCode: 'PK'
  },
  {
    title: 'panama',
    ID: 'PANAMA',
    countryCode: 'PA'
  },
  {
    title: 'peru',
    ID: 'PERU',
    countryCode: 'PE'
  },
  {
    title: 'philippines',
    ID: 'PHILIPPINES',
    countryCode: 'PH'
  },
  {
    title: 'poland',
    ID: 'POLAND',
    countryCode: 'PL'
  },
  {
    title: 'portugal',
    ID: 'PORTUGAL',
    countryCode: 'PT'
  },
  {
    title: 'puerto-rico',
    ID: 'PUERTO_RICO',
    countryCode: 'PR'
  },
  {
    title: 'romania',
    ID: 'ROMANIA',
    countryCode: 'RO'
  },
  {
    title: 'russia',
    ID: 'RUSSIA',
    countryCode: 'RU'
  },
  {
    title: 'saudi-arabia',
    ID: 'SAUDI-ARABIA',
    countryCode: 'SA'
  },
  {
    title: 'scotland',
    ID: 'SCOTLAND',
    countryCode: 'GB',
    regionName: 'Scotland'
  },
  {
    title: 'senegal',
    ID: 'SENEGAL',
    countryCode: 'SN'
  },
  {
    title: 'singapore',
    ID: 'SINGAPORE',
    countryCode: 'SG'
  },
  {
    title: 'slovakia',
    ID: 'SLOVAKIA',
    countryCode: 'SK'
  },
  {
    title: 'slovenia',
    ID: 'SLOVENIA',
    countryCode: 'SI'
  },
  {
    title: 'south-africa',
    ID: 'SOUTH_AFRICA',
    countryCode: 'ZA'
  },
  {
    title: 'spain',
    ID: 'SPAIN',
    countryCode: 'ES'
  },
  {
    title: 'sudan',
    ID: 'SUDAN',
    countryCode: 'SD'
  },
  {
    title: 'sweden',
    ID: 'SWEDEN',
    countryCode: 'SE'
  },
  {
    title: 'switzerland',
    ID: 'SWITZERLAND',
    countryCode: 'CH'
  },
  {
    title: 'taiwan',
    ID: 'TAIWAN',
    countryCode: 'TW'
  },
  {
    title: 'thailand',
    ID: 'THAILAND',
    countryCode: 'TH'
  },
  {
    title: 'trinidad-and-tobago',
    ID: 'TRINIDAD_AND_TOBAGO_REPUBLIC_OF',
    countryCode: 'TT'
  },
  {
    title: 'tunisia',
    ID: 'TUNISIA',
    countryCode: 'TN'
  },
  {
    title: 'turkey',
    ID: 'TURKEY',
    countryCode: 'TR'
  },
  {
    title: 'ukraine',
    ID: 'UKRAINE',
    countryCode: 'UA'
  },
  {
    title: 'united-arab-emirates',
    ID: 'UNITED_ARAB_EMIRATES',
    countryCode: 'AE'
  },
  {
    title: 'united-states',
    ID: 'UNITED_STATES',
    countryCode: 'US'
  },
  {
    title: 'uzbekistan',
    ID: 'UZBEKISTAN',
    countryCode: 'UZ'
  },
  {
    title: 'venezuela',
    ID: 'VENEZUELA',
    countryCode: 'VE'
  },
  {
    title: 'vietnam',
    ID: 'VIETNAM',
    countryCode: 'VN'
  },
  {
    title: 'wales',
    ID: 'WALES',
    countryCode: 'GB',
    regionName: 'Wales'
  }
]
